import { sdk } from 'src/utilities/sdk';
import { camelizeResponseData } from 'src/utilities/http-data-casing';
import {
  BalancePortalUrlApiResponse,
  BalancePortalUrlRawResponse,
} from 'src/types/Balance';

export const getBalancePortalUrlEndpoint = (
  externalBalanceBuyerId: string
): string => `/b2gexternalgateway/balance/portal-url/${externalBalanceBuyerId}`;

export async function fetchBalancePortalUrl(
  externalBalanceBuyerId: string
): Promise<BalancePortalUrlApiResponse> {
  const response: BalancePortalUrlRawResponse = await sdk.http.get(
    getBalancePortalUrlEndpoint(externalBalanceBuyerId)
  );
  return camelizeResponseData(response);
}
